import { Base64 } from 'js-base64';

import { convertFileToBase64 } from './convertFileToBase64';

export async function convertSignFileToBase64(file: File): Promise<string> {
  let text = await file.text();

  if (text.includes('BEGIN CMS')) {
    text = text.replace('-----BEGIN CMS-----\r\n', '').replace('\r\n-----END CMS-----\r\n', '');
  }
  if (Base64.isValid(text)) {
    return text;
  }
  const signText = await convertFileToBase64(file);

  return signText;
}
